export enum ExamResultStatus {
  UNAVAILABLE = "UNAVAILABLE",
  PASSED = "PASSED",
  FAILED = "FAILED",
  MISSING = "MISSING",
}
